/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Мета пагинации архива
 * @export
 * @interface GetNewsList200ResponsePaginate
 */
export interface GetNewsList200ResponsePaginate {
  /**
   *
   * @type {number}
   * @memberof GetNewsList200ResponsePaginate
   */
  totalRecords: number
  /**
   *
   * @type {number}
   * @memberof GetNewsList200ResponsePaginate
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof GetNewsList200ResponsePaginate
   */
  perPage: number
  /**
   *
   * @type {number}
   * @memberof GetNewsList200ResponsePaginate
   */
  lastPage: number
}

/**
 * Check if a given object implements the GetNewsList200ResponsePaginate interface.
 */
export function instanceOfGetNewsList200ResponsePaginate(
  value: object
): value is GetNewsList200ResponsePaginate {
  if (!('totalRecords' in value) || value['totalRecords'] === undefined)
    return false
  if (!('page' in value) || value['page'] === undefined) return false
  if (!('perPage' in value) || value['perPage'] === undefined) return false
  if (!('lastPage' in value) || value['lastPage'] === undefined) return false
  return true
}

export function GetNewsList200ResponsePaginateFromJSON(
  json: any
): GetNewsList200ResponsePaginate {
  return GetNewsList200ResponsePaginateFromJSONTyped(json, false)
}

export function GetNewsList200ResponsePaginateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetNewsList200ResponsePaginate {
  if (json == null) {
    return json
  }
  return {
    totalRecords: json['totalRecords'],
    page: json['page'],
    perPage: json['perPage'],
    lastPage: json['lastPage'],
  }
}

export function GetNewsList200ResponsePaginateToJSON(
  value?: GetNewsList200ResponsePaginate | null
): any {
  if (value == null) {
    return value
  }
  return {
    totalRecords: value['totalRecords'],
    page: value['page'],
    perPage: value['perPage'],
    lastPage: value['lastPage'],
  }
}
